<template>
  <Modal
    :modal-style="{ width: '900px', maxWidth: '800px !important' }"
    persistent
    :title="title"
  >
    <div class="row">
      <QMarkupTable class="full-width wrap">
        <thead>
          <tr>
            <th>Query</th>
            <th>Topic</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(error, index) in reportErrors(report)"
            :key="index"
          >
            <td>{{ error.query }}</td>
            <td>{{ error.topic }}</td>
            <td>{{ error.message }}</td>
          </tr>
        </tbody>
      </QMarkupTable>
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "InsightsReportErrorsModal",
  components: {
    Modal,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      return `Errors for report: ${this.report.id}`;
    },
  },
  methods: {
    reportErrors(report) {
      return JSON.parse(report.processingErrors);
    },
  },
};
</script>
